import type { IModule } from 'redux-dynamic-modules-core';
import { EnvMiddlewares } from './env.middlewares';
import envSlice from './env.slice';

export function EnvModule(): IModule<any>[] {
  return [
    {
      id: envSlice.name,
      reducerMap: {
        [envSlice.name]: envSlice.reducer,
      },
      middlewares: [EnvMiddlewares.currentLanguage],
    },
  ];
}
